module.exports = __webpack_public_path__ + "img/xrzww.680d2e6d.svg";